import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from '@angular/forms';
import { Router } from '@angular/router';

import { FormValidatorsService } from '../../../shared/services/form-validators.service';
import { ErrorMessageLogicService } from '../../../shared/services/error-message-logic.service';
import { UtilityService } from '../../../shared/services/utility.service';
import {
  ValidateVerificationCodeRequest,
  VerificationCodeRequest,
} from 'src/app/shared/models/request';
import { UserService } from 'src/app/service/user.service';
import { RedirectService } from 'src/app/shared/services/redirect.service';
import { SsoRequest } from 'src/app/shared/models/ssorequest';
import { ToastPopUpComponents } from 'src/app/shared/services/toast-popup.service';
import { LoginStatus } from 'src/app/shared/models/loginrequest';
import { UserContext } from 'src/app/shared/models/UserContext';
import { ToastOptions } from 'src/app/core/components/toast/toast.component';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';
import { TranslationService } from 'src/app/service/api/translation.service';

@Component({
  selector: 'app-multi-factor-authentication',
  template: `<div *ngIf="!redirectUserToSite && !accountLocked">
      <div
        id="authenticationChoiceContent"
        class=" tw-w-[90%] app-ml2"
        *ngIf="!verificationCodeSent"
      >
        <h1 role="heading">{{ pageTitle | translation: translationRequest }}</h1>
        <p class="tw-w-full md:tw-w-[60%] app-mt2">
          <app-toast
            [message]="initialMfaToast | translation: translationRequest"
            [type]="toastEnumOptions.Info"
          ></app-toast>
        </p>
        <form
          role="none"
          [formGroup]="verificationMethodForm"
          (ngSubmit)="verificationMethodNext()"
          class="app-ml2"
        >
          <mat-radio-group formControlName="deliverPreference">
            <ul class="" role="none">
              <li
                role="none"
                class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb3 tw-items-start md:tw-items-center"
                *ngIf="!utility.isNullOrEmpty(emailPreference)"
              >
                <div>
                  <mat-radio-button
                    color="primary"
                    labelPosition="after"
                    [value]="'Email'"
                    [attr.aria-label]="'Email receive code via email'| translation: translationRequest"
                  ></mat-radio-button>
                  <span><strong> {{ 'Email' | translation: translationRequest }}: </strong> {{ 'Receive code via email' | translation: translationRequest }}</span>
                </div>
              </li>
              <li
                role="none"
                *ngIf="!utility.isNullOrEmpty(emailPreference)"
                class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb3 app-ml3 tw-items-start md:tw-items-center"
              >
                <label>{{ 'Email Address' | translation: translationRequest }}: {{ hiddenEmail }}</label>
              </li>
              <ng-container
                *ngIf="utility.isNullOrEmpty(emailPreference) && 1 !== 1"
              >
                <li
                  role="none"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb3 tw-items-center"
                  formGroupName="emailGroup"
                >
                  <label for="emailId">{{ 'Email address' | translation: translationRequest }}</label>
                  <mat-form-field>
                    <input
                      matInput
                      id="emailId"
                      autocomplete="off"
                      type="email"
                      formControlName="email"
                      [ngClass]="{
                        'is-invalid':
                          verificationMethodForm.get('deliverPreference')
                            .value === 'Email' &&
                          showErrorMessageForField(
                            verificationMethodForm,
                            'emailGroup.email'
                          )
                      }"
                    />
                  </mat-form-field>
                </li>
                <li
                  role="none"
                  formGroupName="emailGroup"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb3 tw-items-center"
                  *ngIf="
                    verificationMethodForm.get('deliverPreference').value ===
                      'Email' &&
                    showErrorMessageForField(
                      verificationMethodForm,
                      'emailGroup.email'
                    )
                  "
                >
                  <span
                    class="error-message"
                    *ngIf="
                      !verificationMethodForm.get('emailGroup.email').errors
                        ?.['email']
                    "
                  >
                    {{ 'Error : Please enter an email address.' | translation: translationRequest }}
                  </span>
                  <span
                    class="error-message"
                    *ngIf="
                      verificationMethodForm.get('emailGroup.email').errors
                        ?.['email']
                    "
                  >
                    {{ 'Error : Please enter a proper email address.' | translation: translationRequest }}
                  </span>
                </li>
                <li
                  role="none"
                  *ngIf="!emailPreference"
                  formGroupName="emailGroup"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center"
                >
                  <label for="confirmEmailId">{{ 'Confirm email address' | translation: translationRequest }}</label>
                  <mat-form-field>
                    <input
                      matInput
                      autocomplete="off"
                      id="confirmEmailId"
                      type="email"
                      formControlName="confirmEmail"
                      [ngClass]="{
                        'is-invalid':
                          verificationMethodForm.get('deliverPreference')
                            .value === 'Email' &&
                          (verificationMethodForm.get('emailGroup.confirmEmail')
                            .touched ||
                            verificationMethodForm.get(
                              'emailGroup.confirmEmail'
                            ).dirty) &&
                          (verificationMethodForm.get('emailGroup.confirmEmail')
                            .invalid ||
                            verificationMethodForm.get('emailGroup').invalid)
                      }"
                    />
                  </mat-form-field>
                </li>
                <li
                  role="none"
                  formGroupName="emailGroup"
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center"
                  *ngIf="
                    !emailPreference &&
                    verificationMethodForm.get('deliverPreference').value ===
                      'Email' &&
                    (verificationMethodForm.get('emailGroup.confirmEmail')
                      .touched ||
                      verificationMethodForm.get('emailGroup.confirmEmail')
                        .dirty)
                  "
                >
                  <span
                    class="error-message"
                    *ngIf="
                      verificationMethodForm.get('emailGroup.confirmEmail')
                        .errors?.['match']
                    "
                  >
                    {{ 'Error : Please enter a proper email address.' | translation: translationRequest }}
                  </span>
                  <span
                    class="error-message"
                    *ngIf="
                      verificationMethodForm.get('emailGroup').errors?.['match'] &&
                      !verificationMethodForm.get('emailGroup.confirmEmail')
                        .errors?.['email']
                    "
                  >
                    {{ 'Error : The email addresses do not match.' | translation: translationRequest }}
                  </span>
                </li>
              </ng-container>
              <li
                role="none"
                *ngIf="!utility.isNullOrEmpty(phonePreference)"
                class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-start md:tw-items-center"
              >
                <div>
                  <mat-radio-button
                    color="primary"
                    labelPosition="after"
                    [value]="'Text'"
                    [attr.aria-label]="'Text Message receive code on your phone, Standard text message rates apply' | translation: translationRequest"
                  ></mat-radio-button>
                  <span>
                    <strong>{{ 'Text Message:' | translation: translationRequest }}</strong>
                    {{ 'Receive code on your phone (Standard text message rates apply)' | translation: translationRequest }}
                  </span>
                </div>
              </li>
              <li
                role="none"
                class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 app-ml3 tw-items-start md:tw-items-center"
                *ngIf="!utility.isNullOrEmpty(phonePreference)"
              >
                <label for="textNumberId">{{ 'Cell phone number' | translation: translationRequest }} : </label>
                <app-phone
                  [prefilledNumber]="phonePreference"
                  [required]="
                    verificationMethodForm.get('deliverPreference').value ==
                    'Text'
                  "
                  [attemptedSubmission]="chooseVerificationSubmitClicked"
                  [parentId]="componentId"
                  [hidePhoneNumber]="true"
                  formControlName="phoneGroup"
                ></app-phone>
              </li>
            </ul>
          </mat-radio-group>

          <div
            id="authenticationChoiceError"
            *ngIf="
              chooseVerificationError &&
              !(
                verificationMethodForm.get('deliverPreference').value ==
                  'Email' &&
                verificationMethodForm.get('deliverPreference').value == 'Text'
              )
            "
          >
            <span class="error-message">{{
              chooseVerificationErrorMessage
            }}</span>
          </div>

          <p *ngIf="showSsoErrorMessage">
            <app-toast
              [message]="ssoTfaErrorMessage | translation: translationRequest"
              [type]="toastEnumOptions.Error"
            ></app-toast>
          </p>

          <div class="tw-w-full md:tw-w-[60%] tw-flex tw-justify-end app-mt2">
            <app-button
              type="button"
              mat-raised-button
              emphasis="Low"
              (click)="onCancel()"
              class="app-pr2"
              [translationRequest]="translationRequest"
            >
              {{ 'CANCEL' | translation: translationRequest }}
            </app-button>
            <app-button
              mat-raised-button
              type="submit"
              emphasis="High"
              [translationRequest]="translationRequest"
            >
              {{ 'NEXT' | translation: translationRequest }}
            </app-button>
          </div>
        </form>
      </div>

      <div
        id="enterAuthenticationCodeContent"
        class="tw-w-[90%] md:tw-w-[50%] app-mr2 app-ml2"
        *ngIf="verificationCodeSent"
      >
        <h1 role="heading">{{ pageTitle | translation: translationRequest }}</h1>
        <p>
          <app-toast
            [message]="enterVerificationToast | translation: translationRequest"
            [type]="toastEnumOptions.Success"
            *ngIf="!verificationCodeReSent"
          ></app-toast>
          <app-toast
            *ngIf="verificationCodeReSent"
            [message]="newCodeToast | translation: translationRequest"
            [type]="toastEnumOptions.Success"
          ></app-toast>
        </p>
        <form role="none" f [formGroup]="enterVerificationCodeForm">
          <ul role="none">
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2  tw-items-start md:tw-items-center"
            >
              <label for="authCodeId" class="tw-w-full md:tw-w-[50%]"
                >{{ 'Authentication code' | translation: translationRequest }}: *</label
              >
              <mat-form-field class="tw-w-full md:tw-w-[50%]">
                <input
                  maxlength="6"
                  autocomplete="off"
                  #authCodefocus
                  matInput
                  required
                  id="authCodeId"
                  type="text"
                  formControlName="authCode"
                  [ngClass]="{
                    'is-invalid': showErrorMessageForField(
                      enterVerificationCodeForm,
                      'authCode'
                    )
                  }"
                  [attr.aria-label]="'Authentication code' | translation: translationRequest"
                  [title]="authCodeTitle"
                />
                <mat-error
                  *ngIf="
                    showErrorMessageForField(
                      enterVerificationCodeForm,
                      'authCode'
                    )
                  "
                >
                  <mat-error
                    class="error-message"
                    *ngIf="
                      enterVerificationCodeForm.get('authCode').errors?.['required']
                    "
                  >
                    <span>{{ 'Error : Please enter your authentication code.' | translation: translationRequest }}</span>
                  </mat-error>
                </mat-error>
              </mat-form-field>
            </li>
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 app-mt2 tw-items-start "
              *ngIf="showRememberMeBox"
            >
              <div>
                <span>{{ 'Remember this device' | translation: translationRequest }} </span>
                <mat-checkbox
                  color="primary"
                  labelPosition="before"
                  formControlName="rememberDeviceCheck"
                  [attr.aria-label]="'Remember this device' | translation: translationRequest"
                ></mat-checkbox>
              </div>
            </li>
          </ul>
          <p>
            <app-toast
              [message]="oneTimeCodeToast | translation: translationRequest"
              [type]="toastEnumOptions.Info"
              isToastFocus="false"
            ></app-toast>
          </p>
          <p *ngIf="codeStatus === 'EXPIRED'">
            <app-toast
              [message]="expiredMessage | translation: translationRequest"
              [type]="toastEnumOptions.UserError"
            >
            </app-toast>
          </p>
          <p *ngIf="codeStatus == 'ATTEMPTS_EXCEEDED'">
            <app-toast
              [message]="lockoutMessage | translation: translationRequest"
              [type]="toastEnumOptions.UserError"
            >
            </app-toast>
          </p>
          <p *ngIf="codeStatus === 'PENDING' || codeStatus === 'INIT'">
            <app-toast
              [message]="invalidMessage | translation: translationRequest"
              [type]="toastEnumOptions.UserError"
            >
            </app-toast>
          </p>
        </form>
      </div>
      <div
        class="tw-w-full md:tw-w-[50%] tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-justify-end app-mt2"
        *ngIf="verificationCodeSent"
      >
        <app-button
          type="button"
          mat-raised-button
          class="app-mb2 app-mr2"
          (click)="onCancel()"
          emphasis="Low"
          [translationRequest]="translationRequest"
        >
          {{ 'CANCEL' | translation: translationRequest }}
        </app-button>
        <app-button
          *ngIf="showResendButton()"
          type="button"
          mat-raised-button
          emphasis="High"
          class="app-mb2 app-mr2 md:app-mb0 md:app-mr2"
          (click)="resendVerificationCode()"
          [translationRequest]="translationRequest"
        >
          {{ 'RESEND CODE' | translation: translationRequest }}
        </app-button>
        <app-button
          *ngIf="showVerifyCodeButton()"
          mat-raised-button
          emphasis="High"
          type="submit"
          (click)="enterVerificationCodeNext()"
          class="app-mb2  md:app-mb0 "
        >
          {{ 'SUBMIT' | translation: translationRequest }}
        </app-button>
      </div>
    </div>
    <div *ngIf="accountLocked" id="lockPageContent">
      <h1>{{ pageTitle | translation: translationRequest }}</h1>
      <form role="none">
        <div>
          <p>
            <app-toast
              [message]="lockoutMessage | translation: translationRequest"
              [type]="toastEnumOptions.UserError"
            ></app-toast>
          </p>
        </div>
        <div>
          <app-button
            type="button"
            mat-raised-button
            emphasis="Low"
            (click)="onCancel()"
          >
            {{ 'CANCEL' | translation: translationRequest }}
          </app-button>
        </div>
      </form>
    </div> `,
  styles: [``],
})
export class MultiFactorAuthenticationComponent implements OnInit {
  pageTitle: string;
  showTwoFactorForm: boolean;
  verificationMethodForm: UntypedFormGroup;
  enterVerificationCodeForm: UntypedFormGroup;
  emailGroupHasErrors: boolean;
  textGroupHasErrors: boolean;
  chooseVerificationErrorMessage: string;
  chooseVerificationError: boolean;
  verificationDestination: string;
  hiddenCodeDestination: string;
  enterVerificationToast: string;
  verificationCodeSent: boolean;
  redirectUserToSite: boolean;
  verificationTestMessage: string;
  emailPreference: string;
  phonePreference: string;
  emailDestination: string;
  phoneDestination: string;
  emailPreferenceGroup: UntypedFormGroup;
  chooseVerificationSubmitClicked: boolean;
  componentId: string = 'Mfa';
  hiddenEmail: string;
  initialMfaToast: string;
  toastEnumOptions = ToastOptions;
  toastPopUpOptions = ToastPopUpComponents;
  oneTimeCodeToast: string =
    'Your authentication code is a one-time code. You do not have to remember the code.';
  username: string;
  expiredMessage: string =
    'Verification code has expired. Press Resend Code to send another code to your registered email address.';
  lockoutMessage: string = `You have been locked out of your mySedgwick account. Please contact Sedgwick Support Services at (866) 647-7610 or answer <span tabindex='0' class='spanLink' data-function=${this.toastPopUpOptions.unlockAccountPage} >your security questions</span> to unlock your account.`;
  invalidMessage: string =
    'The authentication code you entered is not valid. If you feel you have received this message in error re-enter your code or select the Resend Code button to receive a new code.';
  ssoTfaErrorMessage: string = `You have no valid authentication delivery methods on file.  Please contact your HR Department`;
  showSsoErrorMessage: boolean;
  newCodeToast: string;
  verificationCodeReSent: boolean;
  codeStatus: string;
  showErrorToast: boolean;
  errorToastMessage: string;
  accountLocked: boolean;
  showRememberMeBox: boolean;
  userContext: UserContext;
  ssoRegistration: boolean;

  authCodeTitle: string = this.oneTimeCodeToast.replace('-', ' ');
  @ViewChild('authCodefocus') authCodefocus: ElementRef;
  
  translationRequest = new TranslationRequest(
    {
      language: sessionStorage.getItem('languagepreference'), // Default to English, you can make this dynamic
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,
      group: 'LoginApp',
      subGroup: 'LoginApp'
    }
  );

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private formValidator: FormValidatorsService,
    private showErrorLogic: ErrorMessageLogicService,
    private redirectService: RedirectService,
    private translationService: TranslationService,
    public utility: UtilityService
  ) {}

  get deliverPreference() {
    return this.verificationMethodForm.get(
      'deliverPreference'
    ) as UntypedFormControl;
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  get rememberDeviceCheck() {
    return this.enterVerificationCodeForm.get(
      'rememberDeviceCheck'
    ) as UntypedFormControl;
  }

  async ngOnInit(): Promise<void> {
    this.username = this.userService.username;
    this.pageTitle = 'Authentication Required';
    this.userContext = this.userService.UserContext;
    this.ssoRegistration = this.userService.ssoRegistration;
    //Username should only be null if someone times out on this page or refresh. If this happens
    //I believe the best course of action is to just redirect them to the login page.
    if (this.utility.isNullOrEmpty(this.username)) this.onCancel();

    this.showTwoFactorForm = true;
    this.redirectUserToSite = false;
    this.loadAuthorizationPreferences();
    //If we end up initializing the rememberDeviceCheck to true we need to add
    //check to make sure its hardcoded to false for Liability lob
    this.enterVerificationCodeForm = this.fb.group({
      authCode: ['', { validators: [Validators.required] }],
      rememberDeviceCheck: [false],
    });

    this.setInitialMFAToast();
    this.verificationMethodForm = this.buildChooseVerificationPreferenceForm();

    this.showSsoErrorMessage =
      this.ssoRegistration &&
      this.utility.isNullOrEmpty(this.emailPreference) &&
      this.utility.isNullOrEmpty(this.phonePreference);

    this.deliverPreference.valueChanges.subscribe((value) => {
      if (value == 'Email') {
        this.verificationMethodForm.get('emailGroup').updateValueAndValidity();
        this.verificationMethodForm
          .get('emailGroup.email')
          .updateValueAndValidity();
        this.verificationMethodForm
          .get('emailGroup.confirmEmail')
          ?.updateValueAndValidity();
      } else {
        this.verificationMethodForm
          .get('phoneGroup')
          .get('areaCode')
          ?.updateValueAndValidity();
      }
    });

    this.showRememberMeBox =
      this.userService.loginSubStatus != LoginStatus.PRGLAULogin;

      this.loadTranslations();
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }

  verificationMethodNext(): void {
    this.codeStatus = 'NEW';
    let isEmail = this.deliverPreference.value == 'Email';
    let isText = this.deliverPreference.value == 'Text';
    this.emailDestination = isEmail
      ? this.verificationMethodForm.get('emailGroup')?.get('email').value
      : null;
    this.phoneDestination = isText ? this.getPhoneNumberPreference() : null;

    this.chooseVerificationSubmitClicked = true;

    this.emailGroupHasErrors = this.checkEmailGroupError();
    this.textGroupHasErrors = this.checkTextGroupHasErrors();

    if (
      !this.emailGroupHasErrors &&
      !this.textGroupHasErrors &&
      (isEmail || isText)
    ) {
      this.sendCodeToDevice(this.emailDestination, this.phoneDestination);
    } else {
      this.chooseVerificationError = true;
      if (!isEmail && !isText) {
        this.chooseVerificationErrorMessage =
          'Please select a delivery method to receive your Verification code.';
      }
      if (this.emailGroupHasErrors) {
        this.showEmailGroupErrors();
      }
    }
  }

  resendVerificationCode(): void {
    this.verificationCodeReSent = true;
    this.sendCodeToDevice(this.emailDestination, this.phoneDestination);
    this.codeStatus = 'NEW';
    this.enterVerificationToast = this.newCodeToast;
    this.showErrorToast = false;
    this.enterVerificationCodeForm.get('authCode').setValue('');
    this.enterVerificationCodeForm.get('authCode').setErrors(null);
    this.authCodefocus.nativeElement.focus();
  }

  getPhoneNumberPreference(): any {
    this.verificationMethodForm.get('phoneGroup').updateValueAndValidity();
    return this.verificationMethodForm.get('phoneGroup')?.value;
  }

  enterVerificationCodeNext(): void {
    let verificationCode = this.enterVerificationCodeForm.get('authCode').value;
    let rememberDevice = this.enterVerificationCodeForm.get(
      'rememberDeviceCheck'
    ).value;
    if (this.enterVerificationCodeForm.valid) {
      // this.verificationTestMessage = `Verification code entered. Code: ${verificationCode}, Remember Device: ${rememberDevice}`;
      // this.redirectUserToSite = true;
      let verifyRequest = this.buildValidateVerificationCode();
      this.apiValidateVerificationCode(verifyRequest);
    } else {
      this.enterVerificationCodeForm
        .get('authCode')
        .setErrors({ required: true });
      this.enterVerificationCodeForm.get('authCode').markAsTouched();
      this.authCodefocus.nativeElement.focus();
    }
  }

  apiValidateVerificationCode(
    validateRequest: ValidateVerificationCodeRequest
  ): void {
    this.userService.validateVerificationCode(validateRequest).subscribe(
      (result) => {
        if (result.status == 'VALIDATED') {
          //if (this.rememberDeviceCheck.value)
          //this.verificationTestMessage = `Verification code entered. Code: ${verificationCode}, Remember Device: ${rememberDevice}`;
          this.redirectUserToSite = true;
          if (result.token) {
            this.userService.redirectToken = result.token;
          }
          this.redirectService.redirectToMySedgwick(
            new SsoRequest({
              SessionId: this.userService.sessionid,
              UserName: this.username,
              Token: this.userService.redirectToken,
              MySedgwickUrl: this.userService.mySedgwickUrl,
              ClientType: this.userContext.clientType,
              SourceUrl: this.userService.sourceUrl,
            })
          );
        } else {
          this.codeStatus = result.status;
          this.accountLocked = this.showAccountLockedScreen(this.codeStatus);
          this.userService.username = validateRequest.userName;
        }
      },

      (e) => {
        let response = JSON.parse(e.response);
        console.log(response);
      }
    );
  }

  showResendButton(): boolean {
    // return this.codeStatus == "PENDING" || this.codeStatus == "EXPIRED"
    //         || this.codeStatus == "INIT" || this.codeStatus == "BLANK"
    return this.codeStatus != 'ATTEMPTS_EXCEEDED';
  }

  showVerifyCodeButton(): boolean {
    return (
      this.codeStatus != 'ATTEMPTS_EXCEEDED' && this.codeStatus != 'EXPIRED'
    );
  }

  showAccountLockedScreen(codeStatus: string): boolean {
    return codeStatus == 'ATTEMPTS_EXCEEDED';
  }

  setDeviceCookie(): void {}

  loadAuthorizationPreferences(): void {
    this.emailPreference = this.userService.emailAddress ?? '';
    this.phonePreference =
      this.userService.phoneNumber == '0000000000'
        ? ''
        : this.userService.phoneNumber ?? '';
  }

  setInitialMFAToast(): void {
    this.initialMfaToast =
      'We need to confirm your identity before you can proceed.';
  }

  buildChooseVerificationPreferenceForm(): UntypedFormGroup {
    this.emailPreferenceGroup = this.buildEmailControlGroup();
    return this.fb.group({
      deliverPreference: [this.setInitialDeliverPreference()],
      emailGroup: this.emailPreferenceGroup,
      phoneGroup: [],
    });
  }

  setInitialDeliverPreference(): string {
    return !this.utility.isNullOrEmpty(this.emailPreference) ? 'Email' : 'Text';
  }

  buildEmailControlGroup(): UntypedFormGroup {
    if (!this.emailPreference) {
      return this.fb.group(
        {
          email: ['', { validators: [Validators.email], updateOn: 'blur' }],
          confirmEmail: [
            '',
            { validators: [Validators.email], updateOn: 'blur' },
          ],
        },
        {
          validator: this.formValidator.matchingFields('email', 'confirmEmail'),
        }
      );
    } else {
      this.hiddenEmail = this.hideEmail(this.emailPreference);
      return this.fb.group({
        email: [{ value: this.emailPreference, disabled: true }],
      });
    }
  }

  showEmailGroupErrors(): void {
    let emailControl = this.verificationMethodForm.get('emailGroup.email');
    let confirmEmailControl = this.verificationMethodForm.get(
      'emailGroup.confirmEmail'
    );

    if (!emailControl.value) {
      emailControl.updateValueAndValidity();
      emailControl.setErrors({ email: true });
      emailControl.markAsDirty();
    }
    if (!confirmEmailControl.value) {
      confirmEmailControl.updateValueAndValidity();
      confirmEmailControl.setErrors({ email: true });
      confirmEmailControl.markAsDirty();
    }
  }

  buildSendVerificationRequest(): VerificationCodeRequest {
    return new VerificationCodeRequest({
      UserContext: this.userContext,
      LanguageCode: sessionStorage.getItem('languagepreference'),
    });
  }

  buildValidateVerificationCode(): ValidateVerificationCodeRequest {
    let validateCodeRequestObject: any = {
      userName: this.username,
      verificationCode: this.enterVerificationCodeForm.get('authCode').value,
      setTFADevice: this.enterVerificationCodeForm.get('rememberDeviceCheck')
        .value,
      twoFactorDeviceId: '',
      UserContext: this.userContext,
      token: this.userService.redirectToken,
    };
    return validateCodeRequestObject as ValidateVerificationCodeRequest;
  }

  sendCodeToDevice(email: string, phone: any): void {
    if (!this.utility.isNullOrEmpty(email)) this.sendCodeToEmail();
    else this.sendCodeToPhone();

    this.buildVerificationCodeToast(email, phone);
    this.verificationCodeSent = true;
    this.pageTitle = 'Enter Authentication Code';
  }

  sendCodeToPhone(): void {
    //TO-DO: Fill with call to API for sending to moile device
    this.userService
      .sendTwoFactorMessage(this.buildSendVerificationRequest())
      .subscribe(
        (result) => {
          this.authCodefocus.nativeElement.focus();
        },

        (e) => {
          let response = JSON.parse(e.response);
          console.log(response);
        }
      );
  }

  sendCodeToEmail(): void {    
    this.userService
      .sendVerificationCode(this.buildSendVerificationRequest())
      .subscribe(
        (result) => {
          this.authCodefocus.nativeElement.focus();
        },

        (e) => {
          let response = JSON.parse(e.response);
          console.log(response);
        }
      );
  }

  buildVerificationCodeToast(email: string, phone: any): void {
    let maskedPhone = this.utility.isNullOrEmpty(phone?.fourDigits)
      ? ''
      : `***-***-${phone?.fourDigits}`;
    let maskedEmail = this.utility.isNullOrEmpty(email)
      ? ''
      : this.hideEmail(email);
    this.verificationDestination =
      email && phone
        ? `Your verification code has been sent to: ${maskedEmail} and ${maskedPhone}.`
        : `Your verification code has been sent to: ${
            email ? maskedEmail : maskedPhone
          }.`;

    this.translationService.getTranslationForKey$(this.verificationDestination, this.translationRequest).subscribe((message) => {
      this.verificationDestination = message;
    });

    this.enterVerificationToast = `${this.verificationDestination}`; 

    this.translationService.getTranslationForKey$(this.enterVerificationToast, this.translationRequest).subscribe((message) => {
      this.enterVerificationToast = message;
    });
    this.newCodeToast = `${this.verificationDestination.replace(
      'Your verification',
      'Your new verification'
    )}`;

    this.translationService.getTranslationForKey$(this.newCodeToast, this.translationRequest).subscribe((message) => {
      this.newCodeToast = message;
    });
  }

  showErrorMessageForField(
    formGroup: UntypedFormGroup,
    controlName: string
  ): boolean {
    return this.showErrorLogic.showErrorMessage(formGroup, controlName);
  }

  checkEmailGroupError(): boolean {
    const emailDelivery = this.deliverPreference.value == 'Email';
    const emailControl = this.verificationMethodForm.get('emailGroup.email');
    const confirmEmailControl = this.verificationMethodForm.get(
      'emailGroup.confirmEmail'
    );

    if (emailDelivery) {
      if (this.emailPreference) {
        return false;
      }
      if (
        emailControl.value &&
        emailControl.valid &&
        confirmEmailControl.value &&
        confirmEmailControl.valid &&
        this.verificationMethodForm.get('emailGroup').valid
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (emailDelivery) {
        this.verificationMethodForm.get('emailGroup').setErrors([]);
        this.verificationMethodForm.get('emailGroup.email').setErrors([]);
        this.verificationMethodForm
          .get('emailGroup.confirmEmail')
          ?.setErrors([]);
      }
      return false;
    }
  }

  checkTextGroupHasErrors(): boolean {
    const textNumberControl = this.verificationMethodForm.get('phoneGroup');

    if (this.deliverPreference.value == 'Text') {
      return !textNumberControl.value || textNumberControl.invalid;
    }
    return false;
  }

  hideEmail(email: string): string {
    for (let i = 1; i < email.indexOf('@') - 1; i++) {
      email = email.replace(email.substring(i, i + 1), '*');
    }
    return email;
  }

  formatString(template: string, stringReplacements: string[]): string {
    return template.replace(/{(\d+)}/g, (match, index) => {
      return typeof stringReplacements[index] !== 'undefined' ? stringReplacements[index] : match;
    });
  }
}
